module.exports = __webpack_public_path__ + "db5a57e3268b52967c9c9ab0206c4c.svg";